import { executeRequest, Request } from '@jfs/network'
import { actionMenuStrings } from '../data/static/strings'
import { updateEndDateTimeInRequest } from '../util/util'
import { APIEndPoints } from './APIEndpoints'
import { summaryConfig } from './config'

const responseParser = (data: any) => {
  return data?.data
}

const getSummaryV3 = (
  tokens: any,
  mobile: string,
  reqBody: any,
  type: string,
  isCustomFromRecents = false,
  selectedDate = null,
  abortController: any = null,
) => {
  const getUrl: any = {
    transactions: `${APIEndPoints.getTxnsSummaryV3}`,
    settlements: `${APIEndPoints.getSettlementStats}`,
    refunds: `${APIEndPoints.getTxnsSummaryV3}`,
    voicebox: `${APIEndPoints.getTxnsSummaryV3}`,
  }
  const isInfiniteDateRange =
    (selectedDate?.dateLabel === actionMenuStrings.infiniteScrollRange && type === 'settlements') ||
    selectedDate?.dateLabel === actionMenuStrings.customDate
  const request: Request<{}> = {
    config: summaryConfig(tokens, mobile, abortController),
    apiPath: getUrl[type],
    method: 'POST',
    cache: false,
    body: isCustomFromRecents || isInfiniteDateRange ? reqBody : updateEndDateTimeInRequest(reqBody, selectedDate),
  }
  return executeRequest(request).then((data) => {
    if (data?.data?.status === 'SUCCESS') {
      return responseParser(data?.data)
    } else {
      throw data?.data
    }
  })
}

export { getSummaryV3 }
